import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";
import PropTypes from "prop-types";

function RenderFromHelper({ touched, error }) {
  if (!(touched && !!error)) {
    return <div />;
  }
  return <FormHelperText>{touched && error}</FormHelperText>;
}

function FormSelectorMulti({ input, label, values, names, meta: { touched, error }, ...rest }) {
  const currentValue = Array.isArray(input.value) ? input.value : [];

  return (
    <FormControl sx={{ width: "100%" }} error={touched && !!error}>
      <Autocomplete
        multiple
        id={label}
        options={values}
        value={currentValue}
        onChange={(event, newValue) => {
          input.onChange(newValue);
        }}
        onBlur={() => input.onBlur(currentValue)}
        getOptionLabel={(option) => {
          const val = option;
          const found = names.find((n) => n.uid === val);
          return found ? found.name : String(val);
        }}
        isOptionEqualToValue={(option, value) => option === value}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label={label}
            error={touched && !!error}
            helperText={touched && error ? error : ""}
          />
        )}
        {...rest}
      />
      {RenderFromHelper({ touched, error })}
    </FormControl>
  );
}

RenderFromHelper.defaultProps = {
  touched: false,
  error: "",
};

RenderFromHelper.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.string,
};

FormSelectorMulti.defaultProps = {
  label: "",
  values: [],
  names: [],
  input: {},
  meta: {
    touched: false,
    invalid: false,
    error: "",
  },
};

FormSelectorMulti.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  values: PropTypes.array,
  names: PropTypes.array,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default FormSelectorMulti;
